"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarisPage = exports.StyledPageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
/**
 * This includes visual CSS fixes so Polaris Pages won't break on scroll.
 */
exports.StyledPageContainer = styled_components_1.default.div `
  background: var(--p-color-bg);
  padding: 0 0 40px;
  width: 100%;
  overflow: auto;
  margin-bottom: 20px;
`;
const PolarisPage = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(exports.StyledPageContainer, null,
        react_1.default.createElement(polaris_1.Page, Object.assign({}, rest), children)));
};
exports.PolarisPage = PolarisPage;
